// extracted by mini-css-extract-plugin
module.exports = {"dialog":"LhkxYfAPynGP","content":"_1kHFDTbchAHB","header":"_3oSv2z8_Pejr","control":"_3a5S-Nl0Ot2y","exchange":"YkPdTNOJNmmh"};